// export const API_BASE = "http://localhost:8000";
export const API_BASE = "https://aibackend.crmfarm.in";

export default API_BASE;

